<template>
	<div class="inner-page form-blocks">


		<AppHead title="Manage Form Blocks" />
		
		<PageHeader 
			title="Manage Form Blocks"
			:desc="`Manage the form blocks for the form: <strong>[${form.name}]</strong>`"
			:hasButton="true"
			buttonLabel="New Block"
			:buttonRoute="`/admin/pms-forms/${form.id}/blocks/new`"
			:showHelper="false"
			helpTitle="How to use forms..."
			helpDesc=""
			:backButton="true"
			backLocation="/admin/pms-forms"
			:reverseRightBlock="true"
			/>
			

		<TableFormBlocks 
			:blocks="form.blocks"
			:formID="form.id"
			@addNewFormBlock="addNewForm"
			@editFormBlock="editFormBlock"
			/>


	
	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import { Link } from '@inertiajs/inertia-vue3'
import TableFormBlocks from "@/Components/TableFormBlocks"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Subtitle,
		Placeholder,
		Button,
		Link,
		TableFormBlocks
	},
	layout: AppLayout,
	props: {
		form: [Array, Object]
	},
	data: () => {
		return {
			
		}
	},
	methods: {
		addNewForm(){
			this.$inertia.visit(`/admin/pms-forms/${this.form.id}/blocks/new`)
		},
		editFormBlock(id){
			this.$inertia.visit(`/admin/pms-forms/${this.form.id}/blocks/${id}/edit`)
		}
	},
	mounted(){
		// console.log('form', this.form)
	}
};
</script>

<style lang="sass">

.form-blocks

		

</style>